import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  TextField,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

// Mapping used for dropdown + logic
const PLAYLIST_TYPE_OPTIONS = {
  close_call: "Operational Close Call",
  incident_accident: "Incident / Accident",
  assurance: "Assurance",
};

const managerOptions = [
  "external_contractor",
  "maintenance",
  "principal_contractor",
  "high_output",
  "work_delivery",
  "operations",
  "not_applicable",
];

const InfoStep = ({ formData, formErrors, handleChange }) => {
  const { playlistType } = formData;

  return (
    <Box>
      {/* Playlist Name */}
      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.name}>
        <FormLabel>Name</FormLabel>
        <TextField
          name="name"
          type="text"
          placeholder="Enter Playlist Name"
          value={formData.name || ""}
          onChange={handleChange}
          fullWidth
          variant="outlined"
        />
        {formErrors.name && <FormHelperText>{formErrors.name}</FormHelperText>}
      </FormControl>

      {/* Playlist Description */}
      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.description}>
        <FormLabel>Description</FormLabel>
        <TextField
          name="description"
          type="text"
          placeholder="Enter Playlist Description"
          value={formData.description || ""}
          onChange={handleChange}
          fullWidth
          variant="outlined"
        />
        {formErrors.description && (
          <FormHelperText>{formErrors.description}</FormHelperText>
        )}
      </FormControl>

      {/* Review Type Dropdown */}
      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.playlistType}>
        <FormLabel>Type</FormLabel>
        <TextField
          select
          name="playlistType"
          value={playlistType || ""}
          onChange={handleChange}
          fullWidth
          variant="outlined"
        >
          {Object.entries(PLAYLIST_TYPE_OPTIONS).map(([value, label]) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </TextField>
        {formErrors.playlistType && (
          <FormHelperText>{formErrors.playlistType}</FormHelperText>
        )}
      </FormControl>

      {/* PPS Number */}
      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.ppsNumber}>
        <FormLabel>PPS Number</FormLabel>
        <TextField
          name="ppsNumber"
          type="text"
          placeholder="Enter PPS Number"
          value={formData.ppsNumber || ""}
          onChange={handleChange}
          fullWidth
          variant="outlined"
        />
        {formErrors.ppsNumber && (
          <FormHelperText>{formErrors.ppsNumber}</FormHelperText>
        )}
      </FormControl>

      {/* Worksite */}
      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.worksite}>
        <FormLabel>Worksite</FormLabel>
        <TextField
          name="worksite"
          type="text"
          placeholder="Enter Worksite"
          value={formData.worksite || ""}
          onChange={handleChange}
          fullWidth
          variant="outlined"
        />
        {formErrors.worksite && (
          <FormHelperText>{formErrors.worksite}</FormHelperText>
        )}
      </FormControl>

      {/* Notes (for close_call) */}
      {playlistType === "close_call" && (
        <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.notes}>
          <FormLabel>Notes</FormLabel>
          <TextField
            name="notes"
            placeholder="Enter notes"
            multiline
            rows={3}
            value={formData.notes || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
          />
          {formErrors.notes && (
            <FormHelperText>{formErrors.notes}</FormHelperText>
          )}
        </FormControl>
      )}

      {/* Incident/Accident-specific fields */}
      {playlistType === "incident_accident" && (
        <>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  name="fatality"
                  checked={!!formData.fatality}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: "fatality",
                        value: e.target.checked,
                      },
                    })
                  }
                />
              }
              label="Fatality involved"
            />
          </FormControl>

          <FormControl
            fullWidth
            sx={{ mb: 2 }}
            error={!!formErrors.possessionManager}
          >
            <FormLabel>Possession Manager</FormLabel>
            <TextField
              select
              name="possessionManager"
              value={formData.possessionManager || ""}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            >
              {managerOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            {formErrors.possessionManager && (
              <FormHelperText>{formErrors.possessionManager}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            fullWidth
            sx={{ mb: 2 }}
            error={!!formErrors.worksiteManager}
          >
            <FormLabel>Worksite Manager</FormLabel>
            <TextField
              select
              name="worksiteManager"
              value={formData.worksiteManager || ""}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            >
              {managerOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            {formErrors.worksiteManager && (
              <FormHelperText>{formErrors.worksiteManager}</FormHelperText>
            )}
          </FormControl>
        </>
      )}
    </Box>
  );
};

export default InfoStep;
